import { Button } from "@svea/design-system-components-react";
import { P, Stack, Text, useText } from "@sveabank/cc-common";
import type React from "react";
import { useState } from "react";
import Paper from "../../../../components/paper";
import type { ClcShareholder } from "../../../../types/clc-application";
import { DeleteShareholderModal } from "./delete-shareholder-modal";
import { EditShareholderModal } from "./edit-shareholder-modal";

type ShareholderProps = {
	shareholder: ClcShareholder;
	isApplicant: boolean;
	deleteShareholder: (nationalId: string) => void;
	saveShareholder: (shareholder: ClcShareholder) => void;
	allShareholders: Array<ClcShareholder>;
};

const Shareholder: React.FC<ShareholderProps> = ({
	shareholder,
	isApplicant,
	deleteShareholder,
	saveShareholder,
	allShareholders,
}) => {
	const [t, texts] = useText();

	const [isEditShareholderModalOpen, setIsEditShareholderModalOpen] = useState(false);
	const [isDeleteShareholderModalOpen, setIsDeleteShareholderModalOpen] = useState(false);

	const onDeleteShareholder = (nationalId: string) => {
		deleteShareholder(nationalId);
		setIsDeleteShareholderModalOpen(false);
	};

	const onEditShareholder = (shareholder: ClcShareholder) => {
		saveShareholder(shareholder);
		setIsEditShareholderModalOpen(false);
	};

	return (
		<>
			<Paper className={isApplicant ? "bg-background-tertiary" : "bg-background-primary"}>
				<Stack gap={0} fullSize>
					<Stack direction="row" justify="between">
						<P>
							<Text bold>
								{shareholder.firstName} {shareholder.lastName}
							</Text>
						</P>
						{!isApplicant && (
							<Stack direction="row" gap={1} justify="end">
								<Button
									variant="icon"
									icon="trash"
									aria-label={t(texts.common.remove)}
									onPress={() => setIsDeleteShareholderModalOpen(true)}
								/>
								<Button
									variant="icon"
									icon="pencil"
									aria-label={t(texts.common.change)}
									onPress={() => setIsEditShareholderModalOpen(true)}
								/>
							</Stack>
						)}
					</Stack>
					<P>{shareholder.email}</P>
					<P>{shareholder.postalAddress}</P>
					<P>
						{shareholder.postCode} {shareholder.town}
					</P>
				</Stack>
			</Paper>
			<EditShareholderModal
				open={isEditShareholderModalOpen}
				setOpen={setIsEditShareholderModalOpen}
				saveShareholder={onEditShareholder}
				person={shareholder}
				allShareholders={allShareholders}
			/>
			<DeleteShareholderModal
				open={isDeleteShareholderModalOpen}
				setOpen={setIsDeleteShareholderModalOpen}
				deleteShareholder={onDeleteShareholder}
				person={shareholder}
			/>
		</>
	);
};

export default Shareholder;
